import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { Reveal, EASE } from "./Reveal";
import { AUDIENCE_ITEMS, IMAGES } from "@/data/content";
import { CTAButton } from "./CTAButton";

export const TargetAudience = () => {
  return (
    <section id="fuer-wen" data-testid="target-audience" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-[0.85fr_1fr] lg:items-center lg:gap-16">
          <div className="relative order-2 lg:order-1">
            <div className="overflow-hidden rounded-3xl border border-white/10">
              <img src={IMAGES.sedan} alt="Modernes Fahrzeug" className="aspect-[4/5] w-full object-cover" />
            </div>
            <div className="absolute inset-0 rounded-3xl bg-[radial-gradient(70%_50%_at_50%_100%,rgba(30,155,255,0.25),transparent)]" />
          </div>

          <div className="order-1 lg:order-2">
            <Reveal>
              <span className="font-heading text-xs font-semibold uppercase tracking-[0.24em] text-brand-blue">
                Für wen ist das interessant?
              </span>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-5 font-heading text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl">
                Fahrzeugüberführung könnte zu dir passen, wenn …
              </h2>
            </Reveal>

            <ul className="mt-8 space-y-3.5">
              {AUDIENCE_ITEMS.map((item, i) => (
                <motion.li
                  key={item}
                  initial={{ opacity: 0, x: -16 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.5, delay: i * 0.07, ease: EASE }}
                  className="flex items-start gap-4"
                >
                  <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand-green/15 text-brand-green">
                    <Check className="h-4 w-4" strokeWidth={3} />
                  </span>
                  <span className="font-body text-base text-white/85 sm:text-lg">{item}</span>
                </motion.li>
              ))}
            </ul>

            <Reveal delay={0.1}>
              <p className="mt-8 max-w-xl font-body text-base leading-relaxed text-white/60">
                Du musst kein Autoexperte sein und brauchst keine jahrelange Erfahrung. Im Webinar
                zeige ich dir die Grundlagen von Anfang an.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-8">
                <CTAButton testId="audience-cta" size="md">Jetzt kostenlos teilnehmen</CTAButton>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
